import { useState } from 'react'
import { ignitionFetch } from '~/utils/ignitionFetch'

const useEnrolmentForm = () => {
  const [enrolmentForm, setEnrolmentForm] = useState({ loading: true, data: null, error: null })

  const getEnrolmentForm = (serviceId, childId, token) => {
    ignitionFetch(`api/v1/enrolment-form/service/${serviceId}/child/${childId}`, token, {})
      .then(response => {
        setEnrolmentForm({ loading: false, data: response.data, error: null })
      })
      .catch(res => {
        setEnrolmentForm({
          loading: null,
          error: res.errors
            ? res.errors
            : 'We could not find a completed Custom Enrolment Form for this child.'
        })
      })
  }

  return [enrolmentForm, getEnrolmentForm]
}

export default useEnrolmentForm
